import { Color4, MeshBuilder, Scene, Vector3 } from '@babylonjs/core';

export function polyline(name: string, options: { path: Vector3[], width: number, closed: boolean }, scene?: Scene) {
    const points = [...options.path];
    if(options.closed){
        points.push(options.path[0]);
    }
    const linesMesh = MeshBuilder.CreateLines(name, { points, updatable: false }, scene);
    linesMesh.edgesColor = new Color4(0, 0, 1);
    linesMesh.edgesWidth = options.width;
    linesMesh.enableEdgesRendering();
    return linesMesh;
}